import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useServicesContext } from '../../contexts/ServicesContext';
import { GET_EFFECTIVE_TEAM_SCHEDULING_SETTINGS_QUERY_KEY } from '../queries/useGetEffectiveTeamSchedulingSettings';
import { GET_TEAM_SCHEDULING_SETTINGS_QUERY_KEY } from '../queries/useGetTeamSchedulingSettings';

const invalidateTeamSchedulingCache = (
  queryClient: ReturnType<typeof useQueryClient>,
  teamId: number,
): void => {
  queryClient.invalidateQueries({
    queryKey: [GET_EFFECTIVE_TEAM_SCHEDULING_SETTINGS_QUERY_KEY, teamId],
  });
  queryClient.invalidateQueries({
    queryKey: [GET_TEAM_SCHEDULING_SETTINGS_QUERY_KEY, teamId],
  });
};

export const useDeleteTeamSchedulingSettingsMutation = (teamId: number) => {
  const queryClient = useQueryClient();
  const { deleteTeamSchedulingSettings } = useServicesContext();

  return useMutation({
    mutationKey: ['DELETE_TEAM_SCHEDULING_SETTINGS', teamId],
    mutationFn: () => deleteTeamSchedulingSettings(teamId),
    onSuccess: () => invalidateTeamSchedulingCache(queryClient, teamId),
  });
};
